import React from "react";
import { Entry } from "contentful";
import { IPopupSiteWide } from "../../contentfulTypes";
import PictureWrapper from "../PictureWrapper";
import RichText from "../RichText";

import "./popupSiteWide.style.css";
import { set } from "lodash";

interface IProps {
  data: Entry<IPopupSiteWide>;
  history: any;
}

const PopupSiteWide = (props: IProps) => {
  const { data, history } = props;
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    const modalShown = window.sessionStorage.getItem(
      "modalShown_" + data.sys.id
    );
    setIsOpen(modalShown ? false : true);
  }, [data.sys.id]);

  if (!data) {
    return null;
  }
  if (!isOpen) {
    return null;
  }

  // Skip rendering modal for bot/crawler visits (e.g., prerender.io)
  const userAgent = navigator.userAgent.toLowerCase();
  if (/prerender|bot|crawler|spider|headless/.test(userAgent)) {
    return null;
  }

  const closeModal = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    window.sessionStorage.setItem(
      "modalShown_" + data.sys.id,
      JSON.stringify(true)
    );
    setIsOpen(false);
  };

  // Same close logic, but doesn't preventDefault so the link can still navigate
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    window.sessionStorage.setItem(
      "modalShown_" + data.sys.id,
      JSON.stringify(true)
    );
    setIsOpen(false);
  };

  return (
    <div
      className="popupSiteWide__container"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="popupSiteWide"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: data.fields.backgroundColor
            ? data.fields.backgroundColor
            : "#FFFFFF",
        }}
      >
        {data.fields.photo && (
          <a
            href={data.fields.buttonUrl}
            target={
              data.fields.buttonUrl?.substr(0, 24) ===
                "https://www.curacao.com/" ||
              data.fields.buttonUrl?.startsWith("/")
                ? "_self"
                : "_blank"
            }
            className="popupSiteWide__photo"
            onClick={handleLinkClick}
          >
            <PictureWrapper
              className={`popupSiteWide__photo-img2`}
              options={[
                ["fit", "fill"],
                ["q", "80"],
              ]}
              small={[600, false]}
              medium={[600, false]}
              large={[600, false]}
              asset={data.fields.photo}
            />
          </a>
        )}

        <div
          className="popupSiteWide__close"
          role="presentation"
          onClick={closeModal}
        >
          <span className="popupSiteWide__close-icon" />
        </div>
      </div>
    </div>
  );
};
export default PopupSiteWide;
